import Mustache from 'mustache';
import * as Records from '../../types/bills';

export const GLOBAL_DEFAULT_PRODUCT_DESCRIPTION_TEMPLATE =
  '{{{ commodity }}} {{{ variety }}} {{{ packStyle }}} {{{ label }}} {{{ grade }}} {{{ organic }}} {{{ countryOfOrigin }}}';

export default description;

export function description(
  product: {
    commodity: { name: string };
    commodityStyle: { name: string };
    commodityLabel?: { name: string } | null;
    commoditySize: { name: string };
    grade?: string | null;
    organic?: boolean;
    countryOfOrigin: string | null;
    customFields?: unknown;
  },
  overrideTemplate?: string | null
) {
  return descriptionFromRecords(
    {
      commodity: {
        name: product?.commodity.name,
        style: product?.commodityStyle?.name,
        label: product?.commodityLabel?.name,
        size: product?.commoditySize?.name,
      },
      grade: product?.grade,
      organic: product?.organic,
      countryOfOrigin: product?.countryOfOrigin,
      customFields: product?.customFields || {},
    },
    overrideTemplate ?? undefined
  );
}

export function descriptionFromRecords(
  product: {
    commodity: { name: string; style?: string; label?: string; size?: string };
    grade?: string | null;
    organic?: boolean;
    countryOfOrigin: string | null;
    customFields?: Record<string, any>;
  },
  overrideTemplate?: string
) {
  if (!product) {
    return '';
  }

  const template = overrideTemplate || GLOBAL_DEFAULT_PRODUCT_DESCRIPTION_TEMPLATE;

  // We have determined that our users will expect to see product descriptions in line items
  // and elsewhere in this order: commodity, variety, pack style, grade, country of origin
  // in our system, products have commodity, commodityStyle, commoditySize, commodityUnit, commodityLabel, and grade.
  const attributes = {
    commodity: product.commodity?.name,
    variety: product.commodity?.style,
    packStyle: product.commodity?.size,
    label: product.commodity?.label,
    grade: product.grade,
    organic: product.organic ? 'Organic' : '',
    countryOfOrigin: product.countryOfOrigin,
    customFields: product.customFields || {},
  };

  const rendered = Mustache.render(template, attributes);

  return rendered.trim().replace(/\s+/g, ' ');
}

export function reasonFromRecords(
  bill: Records.Bill,
  lineItem: Records.BillLineItem,
  orderContext: Records.BillOrderContext
): { balancingReason: string; reason: string } {
  const inventoryOrExpense = lineItem.productId ? `Inventory` : `Expense`;
  const purchaseOrSale = bill.type === 'INVOICE' ? `Sale` : `Purchase`;

  let balancingReason = `${purchaseOrSale}`;
  let reason = orderContext
    ? `${inventoryOrExpense} ${purchaseOrSale} for Order ${orderContext.slug}`
    : `${inventoryOrExpense} ${purchaseOrSale}`;

  return { balancingReason, reason };
}
